import React from 'react';

export default function VolumenOnIcon() {
  return (
    <svg
      width="54px"
      height="54px"
      viewBox="0 0 54 54"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Group volume on</title>
      <defs>
        <path
          d="M30.7469792,0.518476012 C31.438637,-0.172972989 32.5598667,-0.172803683 33.2513157,0.518854167 C40.8556305,8.12546586 40.8556305,20.4557841 33.2513157,28.0623958 C32.5598667,28.7540537 31.438637,28.754223 30.7469792,28.062774 C30.0553213,27.371325 30.055152,26.2500954 30.746601,25.5584375 C36.9683132,19.3348461 36.9683132,9.24640388 30.746601,3.0228125 C30.055152,2.33115465 30.0553213,1.20992501 30.7469792,0.518476012 Z M19.4791667,1.89479167 L19.4791667,26.6864583 C19.4791667,28.1713131 17.7615793,28.9968283 16.6021025,28.0692469 L8.23299187,21.3739583 L1.77083333,21.3739583 C0.792829089,21.3739583 8.8817842e-16,20.5811292 8.8817842e-16,19.603125 L8.8817842e-16,8.978125 C8.8817842e-16,8.00012076 0.792829089,7.20729167 1.77083333,7.20729167 L8.23299187,7.20729167 L16.6021025,0.51200315 C17.7615793,-0.415578255 19.4791667,0.409936923 19.4791667,1.89479167 Z M15.9375,5.5792315 L9.96039748,10.3609135 C9.64640562,10.612107 9.25627244,10.7489583 8.85416667,10.7489583 L3.54166667,10.7489583 L3.54166667,17.8322917 L8.85416667,17.8322917 C9.25627244,17.8322917 9.64640562,17.969143 9.96039748,18.2203365 L15.9375,23.0020185 L15.9375,5.5792315 Z M24.4959375,6.76951768 C25.1875953,6.07806868 26.308825,6.07823798 27.000274,6.76989583 C31.1480821,10.9189568 31.1480821,17.6445849 27.000274,21.7936458 C26.308825,22.4853037 25.1875953,22.485473 24.4959375,21.794024 C23.8042797,21.102575 23.8041103,19.9813454 24.4955593,19.2896875 C27.2607647,16.5236469 27.2607647,12.0398948 24.4955593,9.27385417 C23.8041103,8.58219632 23.8042797,7.46096668 24.4959375,6.76951768 Z"
          id="path-1"
        ></path>
      </defs>
      <g
        id="Video-UI-Simple-Player-desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id='MacBook-Pro-16"-Publi-Skip' transform="translate(-181, -267)">
          <g id="Group-volume-on" transform="translate(183, 269)">
            <circle
              id="Oval"
              stroke="#FFFFFF"
              strokeWidth="2"
              fill="#14B395"
              opacity="0.9"
              cx="25"
              cy="25"
              r="26"
            ></circle>
            <g id="volume-2" transform="translate(5.5208, 10.8333)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"></use>
              </mask>
              <use id="Combined-Shape" fill="#FFFFFF" fillRule="nonzero" xlinkHref="#path-1"></use>
              <g id="COLOR/-black" mask="url(#mask-2)" fill="#FFFFFF">
                <g transform="translate(-1.7708, -7.0833)" id="Rectangle">
                  <rect x="0" y="0" width="42.5" height="42.5"></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
